import React from "react";

//Custom Portal Components
import ContactsSection from "../components/CampaingPageComponents/ContactsSection";

//Styles
// .contacts-page-container expande la tabla a casi todo el ancho de la ventana.
import "./StyledPages/ContactsPage.css";

/**
 * Página de Contactos (opción propia del menú superior).
 * Muestra la lista de contactos de WhatsApp con búsqueda, filtros, alta,
 * modificación, eliminación e importación.
 */
export default function ContactsPage() {
    return (
        <div className="contacts-page-container">
            {/* active=true: la sección carga los contactos al montarse */}
            <ContactsSection active={true} />
        </div>
    );
}
